import * as React from "react";
import Modal from "../../../../ui/modal/Modal";
import Asset from "../../../../../model/asset/Asset";
import Loading from "../../../../ui/loading/Loading";
import {api} from "../../../../../api/api";
import {none, Option, option} from "ts-option";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import AssetMaterialsBreakdown from "../../../../../model/asset/AssetMaterialsBreakdown";
import AssetFragmentFormComponent from "../assetFragment/AssetFragmentFormComponent";

interface ComponentProps {
	/**
	 * Asset id
	 */
	assetId: string;
	/**
	 * On close.
	 */
	onClose: () => void;
}

interface State {
	/**
	 * List of materials for each merchant
	 */
	materialsBreakdown: Option<AssetMaterialsBreakdown[]>;
	/**
	 * Indicates if materials data is loading.
	 */
	isLoading: boolean;
}

export default class AssetMaterialsBreakdownModal extends React.Component<ComponentProps, State> {
	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			materialsBreakdown: none,
			isLoading: true
		};
	}

	componentDidMount() {
		api.instance.assetApi.fetchAssetMaterialsBreakdown(this.props.assetId)
			.then(mBreakdown => this.setState({materialsBreakdown: option(mBreakdown), isLoading: false}))
			.catch((e) => {
				this.props.onClose();
				notifyBugsnagAndShowToast(e, "Fetch asset materials breakdown");
			});
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={"Materials breakdown for Asset #" + this.props.assetId}
				   fixedWidth={true}>
				<Loading isLoading={this.state.isLoading}>
					<AssetFragmentFormComponent assetId={this.props.assetId}
												materialsBreakdown={this.state.materialsBreakdown}
												onClose={this.props.onClose}/>
				</Loading>
			</Modal>
		)
	}
}
